import React from "react";
import Header from "../components/layout/Header";
import { useNavigate } from "react-router-dom";
import { useFacility } from "../context/FacilityContext";

function SelectFacility() {
  const navigate = useNavigate();
  const { setFacility } = useFacility();

  const handleFacilitySelection = (facilityName, facilityId) => {
    setFacility(facilityName);

    if (facilityName === "erciyes") {
      const token = localStorage.getItem("accessToken");
      const user = localStorage.getItem("user"); // user JSON olarak saklanıyor varsayıyoruz

      if (!token || !user) {
        console.error("Token veya kullanıcı bilgisi bulunamadı.");
        return;
      }

      const encodedUser = encodeURIComponent(user); // JSON string’i URL’ye uygun hale getir
      const redirectUrl = `https://tibbidanismanlik.onedose.io/auth-redirect?token=${token}&user=${encodedUser}`;
      window.location.href = redirectUrl;
    } else {
      navigate(`/new-application/${facilityId}?facility=${facilityName}`);
    }
  };

  return (
    <div>
      <Header />
      <div className="md:ml-64 flex justify-center items-center">
        <h1 className="text-xl mt-10 text-center">
          Lütfen başvuru yapacağınız kurumu seçiniz
        </h1>
      </div>
      <div className="mb-5 grid grid-cols-2 md:ml-64 ps-5 mt-5 ms-5 me-5 text-xl text-start font-semibold gap-4">
        {/* Hacettepe Seçeneği */}
        {/* <button
          onClick={() => handleFacilitySelection("başkent", 0)}
          className="card relative border border-gray-300 p-4 rounded-lg shadow-md hover:shadow-lg transition"
        >
          <img
            style={{ display: "block", margin: "auto", width: "300px" }}
            src="/assets/images/facilities/hacettepelogo3.png"
            alt="Hacettepe Üniversitesi"
          />
        </button> */}

        {/* Başkent Seçeneği */}
        <button
          onClick={() => handleFacilitySelection("başkent", 0)}
          className="card relative border border-gray-300 p-4 rounded-lg shadow-md hover:shadow-lg transition"
        >
          <img
            style={{ display: "block", margin: "auto", width: "300px" }}
            src="/assets/images/facilities/logo_baskent-tr.png"
            alt="Başkent Üniversitesi"
          />
        </button>

        {/* Erciyes Seçeneği */}
        {/* <button
          onClick={() => handleFacilitySelection("erciyes", 1)}
          className="card relative border border-gray-300 p-4 rounded-lg shadow-md hover:shadow-lg transition"
        >
          <img
            style={{ display: "block", margin: "auto", width: "300px" }}
            src="/assets/images/facilities/erciyes.png"
            alt="Erciyes Üniversitesi"
          />
        </button> */}
      </div>
    </div>
  );
}

export default SelectFacility;
